/* Suma el porcentaje indicado a un color (RR, GG o BB) hexadecimal para aclararlo */
const addLight = function (color: any, amount: any) {
  let cc = parseInt(color, 16) + amount;

  let c = cc > 255 ? 255 : cc;
  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
};

/* const hexToRGB = (color) => {
  color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
  let colorRGB = [color.substring(0,2)]
} */

/* Aclara un color hexadecimal de 6 caracteres #RRGGBB segun el porcentaje indicado */
export const lightenColor = (color: any, amount: any) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt(`${(255 * amount) / 100}`);
  return (color = `#${addLight(color.substring(0, 2), amount)}${addLight(color.substring(2, 4), amount)}${addLight(color.substring(4, 6), amount)}`);
};

/* Resta el porcentaje indicado a un color (RR, GG o BB) hexadecimal para oscurecerlo */
const subtractLight = function (color: any, amount: any) {
  let cc = parseInt(color, 16) - amount;

  let c = cc < 0 ? 0 : cc;

  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
};

export const darkenColor = (color: any, amount: any) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt(`${(255 * amount) / 100}`);

  return (color = `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(color.substring(2, 4), amount)}${subtractLight(
    color.substring(4, 6),
    amount
  )}`);
};

function padZero(str: string, len = 2) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export const getContrast = (hex: string, bw = true, returnHEX = true) => {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // https://stackoverflow.com/a/3943023/112731

    if (returnHEX) {
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }

    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? 'dark' : 'light';
  }
  // invert color components
  const r2 = (255 - r).toString(16);
  const g2 = (255 - g).toString(16);
  const b2 = (255 - b).toString(16);
  // pad each with zeros and return
  return '#' + padZero(r2) + padZero(g2) + padZero(b2);
};

// /* Clase para crear comodamente elementos DIV */
// class div {
//   constructor(type, className, text, color) {
//     this.type = type;
//     this.className = className;
//     this.text = text;
//     this.color = color;
//   }
//   render() {
//     let tag = document.createElement(this.type);
//     tag.setAttribute('class', this.className);
//     tag.setAttribute('style', `background-color:${this.color}`);
//     tag.textContent = this.text;
//     return tag;
//   }
// }
// let cajas = document.getElementById('cajas');
// cajas.appendChild(new div('div', 'caja', 'Lighten 20%', lighten('#23B19D', 20)).render());
// cajas.appendChild(new div('div', 'caja', 'Color 100%', '#23B19D').render());
// cajas.appendChild(new div('div', 'caja', 'Darken 20%', darken('#23B19D', 20)).render());
